import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(crearSesion),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(eliminarSesion),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(importarSesion),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(exportarSesion),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchSesiones); //import { all, put, takeLatest, select, call } from 'redux-saga/effects'


import { all, takeLatest, select } from 'redux-saga/effects';
import { SESION_CREAR, SESION_ELIMINAR, SESION_IMPORTAR, SESION_EXPORTAR } from '../actions';
import * as Util from '../util';
import { sesiones as selectorsSesiones, getConfigGeneral } from '../selectors';
var SEPARACION_DATOS_SESION = '$$xx%%__%%xx$$';
var claveProducto, sesionActual, mensajeImportarFicheroIncorrecto;

function crearSesion() {
  var sesiones;
  return _regeneratorRuntime.wrap(function crearSesion$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(selectorsSesiones.getSesiones);

        case 2:
          sesiones = _context.sent;
          Util.setStorageData('sesiones', sesiones);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function eliminarSesion(_ref) {
  var id = _ref.id;
  var sesiones;
  return _regeneratorRuntime.wrap(function eliminarSesion$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(selectorsSesiones.getSesiones);

        case 2:
          sesiones = _context2.sent;
          sesiones = sesiones.filter(function (sesion) {
            return sesion.id !== id;
          });
          Util.setStorageData('sesiones', sesiones);
          Util.removeAllStorage(id);

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function importarSesion(_ref2) {
  var sesion = _ref2.sesion;
  var configGeneral, tituloVentana, textoBoton, textoFiltro, arrayFiltro;
  return _regeneratorRuntime.wrap(function importarSesion$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(getConfigGeneral);

        case 2:
          configGeneral = _context3.sent;
          sesionActual = sesion;
          claveProducto = configGeneral.key;
          mensajeImportarFicheroIncorrecto = configGeneral.gestorSesiones.parametrosImportarExportarSesion.mensajeImportarFicheroIncorrecto || 'Error';
          tituloVentana = configGeneral.gestorSesiones.parametrosImportarExportarSesion.tituloVentanaImportar || '';
          textoBoton = configGeneral.gestorSesiones.parametrosImportarExportarSesion.textoBotonImportar || '';
          textoFiltro = configGeneral.gestorSesiones.parametrosImportarExportarSesion.textoFicheros || '';
          arrayFiltro = [configGeneral.gestorSesiones.parametrosImportarExportarSesion.extensionFicheros] || [''];

          if (window.electronContext && window.cargarFichero) {
            // (async () => await window.cargarFichero (tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados))()
            window.cargarFichero(tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados);
          } else if (window.parent.electronContext && window.parent.cargarFichero) {
            // (async () => await window.parent.cargarFichero (tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados))()
            window.parent.cargarFichero(tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados);
          } else if (!window.electronContext && window.cargarFichero) {
            // FUERA DE ELECTRON
            // (async () => await window.cargarFichero (tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados))()
            window.cargarFichero(tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados);
          } else if (!window.parent.electronContext && window.parent.cargarFichero) {
            // (async () => await window.parent.cargarFichero (tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados))()
            window.parent.cargarFichero(tituloVentana, textoBoton, textoFiltro, arrayFiltro, interpretarDatosImportados);
          } else {//no existe función
          }

        case 11:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function interpretarDatosImportados(fichero, datos) {
  var infoDatos = datos.split(SEPARACION_DATOS_SESION);
  var ficheroContieneKey = infoDatos[0].split(claveProducto).length > 1;

  if (!ficheroContieneKey) {
    Util.alert(mensajeImportarFicheroIncorrecto);
    return;
  }

  var claveSesionGuardada = infoDatos[0].split(':')[0] + ':' + claveProducto;
  var claveSesionNueva = sesionActual.id + ':' + claveProducto;
  var datosProcesados = datos.split(claveSesionGuardada).join(claveSesionNueva).split(SEPARACION_DATOS_SESION);
  importarBorrarDatosExistentes(claveSesionNueva);
  importarInsertarNuevosDatos(datosProcesados);
}

function importarBorrarDatosExistentes(clave) {
  Util.removeAllStorage(clave);
}

function importarInsertarNuevosDatos(datosProcesados) {
  for (var i = 0; i < datosProcesados.length; i += 2) {
    var clave = datosProcesados[i];
    var datos = datosProcesados[i + 1];
    window.localStorage.setItem(clave, datos);
  }
}

function exportarSesion(_ref3) {
  var sesion = _ref3.sesion;
  var configGeneral, clave, datosSesion, mensajeImportarNoDatos, tituloVentana, textoBoton, textoFiltro, arrayFiltro, nombrePorDefecto;
  return _regeneratorRuntime.wrap(function exportarSesion$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(getConfigGeneral);

        case 2:
          configGeneral = _context4.sent;
          clave = sesion.id + ':' + configGeneral.key;
          datosSesion = Util.getAllStorage(clave).join(SEPARACION_DATOS_SESION);

          if (datosSesion.length) {
            _context4.next = 9;
            break;
          }

          mensajeImportarNoDatos = configGeneral.gestorSesiones.parametrosImportarExportarSesion.mensajeImportarNoDatos || 'Sesión sin datos.';
          Util.alert(mensajeImportarNoDatos);
          return _context4.abrupt('return');

        case 9:
          tituloVentana = configGeneral.gestorSesiones.parametrosImportarExportarSesion.tituloVentanaExportar || '';
          textoBoton = configGeneral.gestorSesiones.parametrosImportarExportarSesion.textoBotonExportar || '';
          textoFiltro = configGeneral.gestorSesiones.parametrosImportarExportarSesion.textoFicheros || '';
          arrayFiltro = [configGeneral.gestorSesiones.parametrosImportarExportarSesion.extensionFicheros] || [''];
          nombrePorDefecto = sesion.nombre;

          if (window.electronContext && window.guardarFichero) {
            window.guardarFichero(datosSesion, tituloVentana, textoBoton, textoFiltro, arrayFiltro, nombrePorDefecto);
          } else if (window.parent.electronContext && window.parent.guardarFichero) {
            window.parent.guardarFichero(datosSesion, tituloVentana, textoBoton, textoFiltro, arrayFiltro, nombrePorDefecto);
          } else if (!window.electronContext && window.guardarFichero) {
            // FUERA DE ELECTRON
            window.guardarFichero(datosSesion, tituloVentana, textoBoton, textoFiltro, arrayFiltro, nombrePorDefecto);
          } else if (!window.parent.electronContext && window.parent.guardarFichero) {
            window.parent.guardarFichero(datosSesion, tituloVentana, textoBoton, textoFiltro, arrayFiltro, nombrePorDefecto);
          } else {//no existe función
          }

        case 15:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchSesiones() {
  return _regeneratorRuntime.wrap(function watchSesiones$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.t0 = all;
          _context5.next = 3;
          return takeLatest(SESION_CREAR, crearSesion);

        case 3:
          _context5.t1 = _context5.sent;
          _context5.next = 6;
          return takeLatest(SESION_ELIMINAR, eliminarSesion);

        case 6:
          _context5.t2 = _context5.sent;
          _context5.next = 9;
          return takeLatest(SESION_IMPORTAR, importarSesion);

        case 9:
          _context5.t3 = _context5.sent;
          _context5.next = 12;
          return takeLatest(SESION_EXPORTAR, exportarSesion);

        case 12:
          _context5.t4 = _context5.sent;
          _context5.t5 = [_context5.t1, _context5.t2, _context5.t3, _context5.t4];
          _context5.next = 16;
          return (0, _context5.t0)(_context5.t5);

        case 16:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

export default watchSesiones;